import React from 'react';

const GameCard = ({ item, onClick, onKeyDown }) => {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
      className={`
        group
        ${item.cols || 'col-span-2'}
        rounded-2xl
        cursor-pointer
        select-none
        shadow-lg
        transition
        duration-200
        hover:shadow-2xl
        hover:-translate-y-1
        focus:outline-none focus-visible:ring-4 focus-visible:ring-white/30
        relative
        overflow-hidden
        bg-white
        flex flex-col
      `}
      style={{
        minHeight: ['/daily-quiz', '/mystery-player', '/match-vote', '/sports-games', '/player-review', '/on-this-day', '/mystery-sports-legend'].includes(item.route) ? 'clamp(140px, 14vw, 180px)' : 'clamp(160px, 16vw, 220px)'
      }}
    >
      {item.isFeature ? (
        // Feature Card Layout
        <>
          {item.layout === 'header-title' ? (
            // Type A: Header with Icon + Title, Footer with Description
            <>
              {/* Header with icon + title */}
              <div className={`${item.bgColor} flex items-center ${['/draw-game', '/buy-sell', '/sports-craft', '/sell-sell-sell', '/player-review', '/daily-quiz', '/mystery-player', '/match-vote', '/sports-games', '/on-this-day', '/mystery-sports-legend'].includes(item.route) ? (item.route === '/daily-quiz' ? 'pl-3 pr-3 gap-2' : (item.route === '/mystery-player' ? 'pl-4 pr-3 gap-3' : (['/match-vote', '/sports-games', '/player-review', '/on-this-day', '/mystery-sports-legend', '/sports-craft'].includes(item.route) ? 'pl-3 pr-3 gap-3' : 'pl-1 pr-3 gap-0'))) : 'px-4 gap-3'} relative overflow-hidden`} style={{ height: 'clamp(95px, 10vw, 130px)' }}>
                <div className="flex-shrink-0" style={{ transform: 'scale(clamp(0.85, 1.1vw, 1.3))' }}>
                  {item.icon}
                </div>
                {['/draw-game', '/buy-sell', '/sports-craft', '/sell-sell-sell', '/player-review', '/daily-quiz', '/mystery-player', '/match-vote', '/sports-games', '/on-this-day', '/mystery-sports-legend'].includes(item.route) ? (
                  <div
                    className={`${item.textColor} ml-0 ${
                      item.route === '/sell-sell-sell'
                        ? 'transform translate-x-4'
                        : item.route === '/sports-craft'
                          ? 'transform -translate-y-2'
                          : ''
                    }`}
                    style={{ marginLeft: 0 }}
                  >
                    {item.title}
                  </div>
                ) : (
                  <div className={`font-black leading-tight uppercase tracking-wide drop-shadow-sm ${item.textColor}`} style={{ fontSize: 'clamp(1rem, 1.8vw, 1.5rem)' }}>
                    {item.title}
                  </div>
                )}
                {/* Extra Sparkles for Sell Sell Sell */}
                {item.route === '/sell-sell-sell' && (
                  <div className="absolute inset-0 pointer-events-none">
                     <span className="absolute top-2 right-10 text-white/40 text-[10px] animate-pulse">✦</span>
                     <span className="absolute top-6 right-4 text-white/50 text-[12px] animate-pulse delay-75">✦</span>
                     <span className="absolute bottom-4 right-20 text-white/30 text-[8px] animate-pulse delay-150">✦</span>
                     <span className="absolute top-4 left-1/2 text-white/20 text-[6px] animate-pulse delay-300">✦</span>
                  </div>
                )}
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/10 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              <div className={`flex-1 flex flex-col ${['/sell-sell-sell', '/player-review', '/draw-game', '/buy-sell', '/sports-craft', '/daily-quiz', '/mystery-player', '/match-vote', '/sports-games', '/on-this-day', '/mystery-sports-legend'].includes(item.route) ? (item.route === '/draw-game' ? 'justify-start pt-3' : 'justify-start pt-1') : 'justify-center'} bg-white`} style={{ padding: ['/daily-quiz', '/mystery-player', '/match-vote', '/sports-games', '/player-review', '/on-this-day', '/mystery-sports-legend'].includes(item.route) ? 'clamp(10px, 1.2vw, 18px)' : 'clamp(10px, 1.8vw, 26px)' }}>
                <div className="text-gray-600 font-semibold leading-snug" style={{ fontSize: 'clamp(0.8rem, 1.2vw, 1.25rem)' }}>
                  {item.description}
                </div>
              </div>
            </>
          ) : (
            // Type B: Image Top, Text Bottom (Country Battle)
            <>
              <div className={`${item.bgColor} flex items-center justify-center relative overflow-hidden`} style={{ height: 'clamp(110px, 12vw, 145px)' }}>
                {/* Sunburst/Sky Effect for Country Battle */}
                {item.route === '/country-battle' && (
                  <>
                    {/* Sunburst Rays */}
                    <div className="absolute inset-0 opacity-30">
                      {[...Array(12)].map((_, i) => (
                        <div
                          key={i}
                          className="absolute top-1/2 left-1/2 w-[200%] h-4 bg-white/20 origin-left"
                          style={{ transform: `translate(-50%, -50%) rotate(${i * 30}deg)` }}
                        ></div>
                      ))}
                    </div>
                    {/* Central Glow */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-yellow-200/40 rounded-full blur-2xl"></div>

                    {/* Sparkles */}
                    <div className="absolute inset-0">
                      <span className="absolute top-4 left-10 text-white text-[10px] animate-pulse">✦</span>
                      <span className="absolute top-8 right-12 text-white text-[8px] animate-pulse delay-75">✦</span>
                      <span className="absolute top-2 right-20 text-white text-[12px] animate-pulse delay-150">✦</span>
                      <span className="absolute bottom-12 left-1/4 text-white text-[6px] animate-pulse">✦</span>
                    </div>

                    {/* Field Lines */}
                    <div className="absolute bottom-0 w-full h-[40%] overflow-hidden bg-green-700/30">
                       <div className="absolute bottom-0 left-1/2 w-1 h-full bg-white/20 transform -translate-x-1/2 skew-x-12 origin-bottom"></div>
                       <div className="absolute bottom-0 left-1/2 w-1 h-full bg-white/20 transform -translate-x-1/2 -skew-x-12 origin-bottom"></div>
                       <div className="absolute bottom-[20%] w-full h-[1px] bg-white/10"></div>
                    </div>
                  </>
                )}

                <div className="z-10" style={{ transform: 'scale(clamp(1.0, 1.4vw, 1.7))' }}>
                  {item.icon}
                </div>
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/20 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-20"></div>
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center bg-white">
                <div className="font-black leading-tight uppercase tracking-wide text-gray-800" style={{ fontSize: 'clamp(1rem, 1.8vw, 1.75rem)' }}>
                  {item.title}
                </div>
                <div className="text-gray-600 font-semibold leading-snug mt-2" style={{ fontSize: 'clamp(0.8rem, 1.2vw, 1.25rem)' }}>
                  {item.description}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        // Standard Card Layout (Icon Left, Text Right)
        <div className={`flex items-center gap-4 p-4 h-full ${item.bgColor} ${item.textColor}`}>
          <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-white/20 rounded-xl backdrop-blur-sm shadow-inner">
            {item.icon}
          </div>
          <div className="flex flex-col justify-center text-left z-10">
            <div className="font-black leading-tight uppercase tracking-wide drop-shadow-sm" style={{ fontSize: 'clamp(0.875rem, 1.3vw, 1.25rem)' }}>
              {item.title}
            </div>
            {item.description && (
              <div className="opacity-95 font-medium leading-tight mt-1" style={{ fontSize: 'clamp(0.65rem, 0.9vw, 0.875rem)' }}>
                {item.description}
              </div>
            )}
          </div>
          {/* Decorative background element */}
          <div className="absolute -right-6 -bottom-6 w-24 h-24 bg-white/10 rounded-full blur-xl pointer-events-none"></div>
        </div>
      )}
    </div>
  );
};

export default GameCard;
